'use client';

import { useLocale, useTranslations } from 'next-intl';

import { usePathname, useRouter } from '@/lib/navigation';

export function LocaleSwitcher() {
  const t = useTranslations('localeSwitcher');
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  const switchLocale = (nextLocale: 'en' | 'ja') => {
    if (nextLocale === locale) {
      return;
    }
    router.replace(pathname, { locale: nextLocale });
    router.refresh();
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        fontSize: '0.875rem',
      }}
    >
      <button
        className="lk-button"
        type="button"
        data-testid="locale-switcher-en"
        onClick={() => switchLocale('en')}
        aria-pressed={locale === 'en'}
        style={{ minWidth: 'auto', paddingInline: '0.5rem' }}
      >
        {t('english')}
      </button>
      <span aria-hidden="true">|</span>
      <button
        className="lk-button"
        type="button"
        data-testid="locale-switcher-ja"
        onClick={() => switchLocale('ja')}
        aria-pressed={locale === 'ja'}
        style={{ minWidth: 'auto', paddingInline: '0.5rem' }}
      >
        {t('japanese')}
      </button>
    </div>
  );
}
